export default __webpack_public_path__ + "static/media/Landing_Logo_Iex.fced733a.png";